import credentialsAPI from '@api/credentials'
import { makeMutation } from '@lib/mutation'

interface ChangeEmailMutationRequest {
  userId: string
  email: string
  retailerPartnerNumber: number
}

export const useChangeEmail = makeMutation<ChangeEmailMutationRequest, void>({
  key: 'changeEmail',
  loader: async ({ userId, email, retailerPartnerNumber }) =>
    await credentialsAPI.changeEmail({ userId, email, retailerPartnerNumber }),
})
